import { render, staticRenderFns } from "./ListHeader.vue?vue&type=template&id=ca079378&"
import script from "./ListHeader.vue?vue&type=script&lang=js&"
export * from "./ListHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports